import React from "react";
import { Input } from "../../../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../../../constants";
/**
 * @desc Input eyebrow for product details form.
 */
export const InputProductEyebrow = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-eyebrow-error`,
  };

  const inputProps = {
    type: "text",
    id: `${product.sku}-input-product-eyebrow`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "EYEBROW",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_EYEBROW,
  };

  return <Input {...parentProps} />;
};
